import isString from 'lodash-es/isString';
import Helpers from 'Main/modules/Helpers';
import {
  MEDIA_INITIAL,
  nextCreateCommentStep,
} from 'Plugins/obituary/javascript/createCommentStepsHelper';
import { openMediaPicker, takePickedFiles } from 'Plugins/obituary/javascript/media-picker';

export default {
  state: {
    name: '',
    comment: '',
    email: '',
    modalIsOpen: false,
    prevContext: [],
    modalContext: '',
    steps: {
      form: false,
      donation: false,
      media: false,
      preview: false,
    },
  },

  mutations: {
    updateName(state, name = '') {
      state.name = name;
    },

    updateComment(state, comment = '') {
      state.comment = comment;
    },

    updateEmail(state, comment = '') {
      state.email = comment;
    },

    setModalIsOpen(state, modalIsOpen = true) {
      state.modalIsOpen = modalIsOpen;
    },

    resetPrevContext(state) {
      state.prevContext = [];
    },

    addPrevContext(state, context = '') {
      state.prevContext.push(context);
    },

    removePrevContext(state) {
      state.prevContext.pop();
    },

    setModalContext(state, context = '') {
      state.modalContext = context;
    },

    setStepStatus(state, step = '') {
      state.steps[step] = true;
    },

    undoStepStatus(state, step = '') {
      state.steps[step] = false;
    },
  },

  actions: {
    reset({ commit }) {
      commit('updateName');
      commit('updateComment');
      commit('updateEmail');

      commit('undoStepStatus', 'form');
      commit('undoStepStatus', 'donation');
      commit('undoStepStatus', 'media');
      commit('undoStepStatus', 'preview');
    },

    toggleModal({ state, commit, dispatch, rootState }, modalContext = '') {
      if (state.modalIsOpen && rootState.donations.isDonating) {
        const result = window.confirm(
          lavendlaObituary.createComment.closeWarningIsDonating
        );
        if (!result) {
          return;
        } else {
          dispatch('donations/resetDonation', null, { root: true });
          Helpers.obituaryGreetingsLog('DonationCancelledAfterWarning');
        }
      }

      if (
        state.modalIsOpen &&
        rootState.donations.donation &&
        rootState.donations.donation.donation
      ) {
        const result = window.confirm(
          lavendlaObituary.createComment.closeWarningHasDonationNoMessage
        );
        if (!result) {
          return;
        }

        Helpers.obituaryGreetingsLog('DonatedClosedWithoutGreeting');
      }

      if (
        state.modalIsOpen &&
        rootState.comments.files &&
        rootState.comments.files.length > 0
      ) {
        const result = window.confirm(
          lavendlaObituary.createComment.closeWarningHasFiles
        );
        if (!result) {
          return;
        }

        Helpers.obituaryGreetingsLog('CloseWarningHasFiles');
      }

      if (state.modalIsOpen && state.steps.form) {
        const result = window.confirm(
          lavendlaObituary.createComment.closeWarningHasMessage
        );
        if (!result) {
          return;
        }

        Helpers.obituaryGreetingsLog('CloseWarningHasMessage');
      }

      if (modalContext && isString(modalContext)) {
        commit('setModalContext', modalContext);
      } else {
        commit('setModalContext', '');
      }

      if (rootState.comments.files && rootState.comments.files.length > 0) {
        dispatch('comments/resetFiles', null, { root: true });
      }

      commit('resetPrevContext');
      // A new greeting asks about gifts again.
      commit('undoStepStatus', 'preview');
      commit('setModalIsOpen', !state.modalIsOpen);

      if (!state.modalIsOpen) {
        takePickedFiles();
      } else if (modalContext === MEDIA_INITIAL) {
        openMediaPicker();
      }
    },

    addPrevContext({ commit }, context = '') {
      commit('addPrevContext', context);
    },

    removePrevContext({ commit }) {
      commit('removePrevContext');
    },

    changeModalContext({ commit }, modalContext = '') {
      commit('setModalContext', modalContext);
    },

    updateSteps({ commit }, step = '') {
      commit('setStepStatus', step);
    },

    undoSteps({ commit }, step = '') {
      commit('undoStepStatus', step);
    },

    nextStep({ state, commit, rootState }) {
      commit(
        'setModalContext',
        nextCreateCommentStep(
          state.modalContext,
          state.steps,
          rootState.donations.noDonationsAllowed
        )
      );
    },

    setDetailsFromDonation({ commit }, donation) {
      commit('updateName', donation.name);
      commit('updateEmail', donation.email);
    },
  },

  namespaced: true,
};
